import * as React from 'react';
import closeIcon from 'src/assets/images/close-ic.png'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ProductCompareRepository from "../../../repository/ProductCompareRepository";
import { useSelector } from "react-redux";

const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const { carouselState: { currentSlide } } = rest;
    return (
        <div className='arrows-container'>
            <a className={currentSlide === 0 ? 'disable arrows arrows-left' : 'arrows arrows-left'}
                onClick={() => previous()}><i className='fa fa-chevron-circle-left'></i></a>
            <a className='arrows arrows-right' onClick={() => validateNext() && next()}><i className='fa fa-chevron-circle-right'></i></a>
        </div>
    );
};

const validateNext = () => {
    const compareBox = document.getElementsByClassName('compare-item-list-outer')[0].offsetWidth;
    const activeItem = document.getElementsByClassName('react-multi-carousel-track')[0].clientWidth;
    return (compareBox - (activeItem + 35) < 0) ? true : false;
}

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 10
    },
    largedesktop: {
        breakpoint: { max: 3000, min: 1400 },
        items: 7
    },
    desktop: {
        breakpoint: { max: 1400, min: 1280 },
        items: 6
    },
    miniDesktop: {
        breakpoint: { max: 1280, min: 1024 },
        items: 6
    },
    tabletlandscape: {
        breakpoint: { max: 1024, min: 767 },
        items: 4
    },
    tablet: {
        breakpoint: { max: 767, min: 567 },
        items: 4
    },
    mobile: {
        breakpoint: { max: 567, min: 0 },
        items: 2
    }
};

const BottomCompareItemSlider = (props) => {
    const compareProductList = useSelector((state) => state.entities.model_ProductCompare.data);
    return (
        <>
            <div className="col-12 col-md p-0 position-relative compare-item-list-wrapper">
                <div className="compare-item-list-background" />
                {compareProductList && Object.keys(compareProductList).length > 0 &&
                    <>
                        <div className="compare-item-list-outer">
                            <Carousel
                                swipeable={false}
                                draggable={true}
                                showDots={false}
                                responsive={responsive}
                                ssr={true} // means to render carousel on server-side.
                                infinite={false}
                                autoPlay={false}
                                autoPlaySpeed={12000}
                                keyBoardControl={true}
                                customTransition="all .5"
                                transitionDuration={500}
                                containerClass="carousel-container"
                                removeArrowOnDeviceType={["mobile"]}
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-40-px"
                                renderArrowsWhenDisabled={true}
                                arrows={false}
                                customButtonGroup={<ButtonGroup />}

                            >
                                {

                                    Object.keys(compareProductList).map((v, i) => (
                                        <div key={v} className="comapre-item">
                                            <div className='pe-3'>
                                                <p className="product-link">{compareProductList[v].ERPMFRPartNumber  ? compareProductList[v].ERPMFRPartNumber : ''}</p>
                                                <span className="manufacturer">{compareProductList[v].Manufacturer ? compareProductList[v].Manufacturer : ''}</span>
                                            </div>
                                            <div className="close-ic"
                                                onClick={async () => {
                                                    await new ProductCompareRepository().toggleSingleProduct(compareProductList[v])
                                                    // new BroadcastChannel('product-compare-toggled').postMessage({}); // // 13546
                                                    await new ProductCompareRepository().fetchAllData();
                                                }}
                                            >
                                                <img src={closeIcon} />
                                            </div>
                                        </div>
                                    ))

                                }

                            </Carousel>
                        </div>
                    </>
                }
            </div>
        </>
    );
}

export default BottomCompareItemSlider;